import React, { useContext, useState } from "react";
import AddButton from "../../components/AddButton";
import DialogHT from "../../components/DialogHT";
import { UserContext } from "../../../../Context";
import { useNavigate } from "react-router-dom";
import ProgressHT from "../../components/ProgressHT";
import Info from "../../components/Info";
  
  
export default function Syllabuses({syllabuses, search}) {
  
  const [newSyllabus, setNewSyllabus] = useState(false)
  const { user } = useContext(UserContext)
  const navigate = useNavigate()
  
 

  return (
    <div>
      <AddButton action={() => setNewSyllabus(true)} />
      <DialogHT
        open={newSyllabus}
        setOpen={setNewSyllabus}
        url="/syllabus"
        title="addNewSyllabus"
        http="put"
        content={content}
        extraData={{ createdBy: user._id }}
        success={(res) => syllabuses.add(res)}
      />

      {syllabuses.filter(
        (s) => s.classesUsing.length > 0 && checkSearch(s, search)
      ).length > 0 ? (
        syllabuses
          .filter((s) => s.classesUsing.length > 0 && checkSearch(s, search))
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((syllabus) => (
            <div
              key={syllabus._id}
              className="lesson-button"
              onClick={() => navigate(`/teaching/syllabus/${syllabus._id}`)}
              style={{ display: "flex" }}
            >
              <div style={{ width: 300 }}>
                <div>{syllabus.name}</div>
                {syllabus.issues && <div className="text-xs text-red-500">Issues: {syllabus.issues}</div>}
              </div>
              <Stats syllabus={syllabus} />
              <ClassesUsed syllabus={syllabus} />
              <PercentCompleted syllabus={syllabus} />
            </div>
          ))
      ) : (
        <div>No syllabuses</div>
      )}
      <div
        style={{
          background: "#888",
          color: "white",
          padding: 5,
          marginTop: 10,
        }}
      >
        Not in use
      </div>
      {syllabuses.filter(
        (s) => s.classesUsing.length === 0 && checkSearch(s, search)
      ).length > 0 ? (
        syllabuses
          .filter((s) => s.classesUsing.length === 0 && checkSearch(s, search))
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((syllabus) => (
            <div
              key={syllabus._id}
              className="lesson-button"
              onClick={() => navigate(`/teaching/syllabus/${syllabus._id}`)}
              style={{ display: "flex" }}
            >
              <div style={{ width: 300 }}>{syllabus.name}</div>
              <Stats syllabus={syllabus} />
              <ClassesUsed syllabus={syllabus} />
              <PercentCompleted syllabus={syllabus} />
            </div>
          ))
      ) : (
        <div>No syllabuses</div>
      )}
    </div>
  );
}

function checkSearch(syllabus, search) {
  if (!search) return true
  if (syllabus.name.toLowerCase().includes(search.toLowerCase())) return true
  for (const c of syllabus.classesUsing) {
    if(c.name.toLowerCase().includes(search.toLowerCase())) return true
  }
  return false
}

function Stats({ syllabus }){
  
  return (
    <div style={{width:200}}>
      <div>Units: {syllabus.units.length}</div>
      <div>Lessons: {syllabus.lessons.length + syllabus.units.length}</div>
    </div>
  );
}

function ClassesUsed({ syllabus }) {
  
  return <Info title="Classes using this syllabus" style={{flexGrow:1}} body={syllabus.classesUsing.map(c => c.name).toString()} />
}

function PercentCompleted({ syllabus }) {
  
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 5,
        color: "#888",
        fontSize: 12,
        width: 130,
        marginRight: 10,
      }}
    >
      <div style={{ width: 100 }}>
        <ProgressHT value={syllabus.percentComplete} />
      </div>
      <div style={{ width: 20, textAlign: "center" }}>
        {parseInt(syllabus.percentComplete) || 0}%
      </div>
    </div>
  );
}


const content = [{
  name: "name",
  label: "name",
  type: "text"
},
  { name: "numberOfLessons", label: "numberOfLessons", type: "number" }]